// clientV3.js
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { isAuthenticated } from "./lib/auth";

function getGraphQLEndpoint(endpoint) {
  if (endpoint) return endpoint;

  const isMiniApp = window.location.search.includes("miniapp");
  const hasMiniToken =
    isMiniApp &&
    localStorage.getItem("access") &&
    localStorage.getItem("access") !== "initial";

  const authed = isAuthenticated() || hasMiniToken;
  const IS_CUSTOMER_VAL =
    localStorage.getItem("is_customer") &&
    localStorage.getItem("is_customer") === "yes"
      ? true
      : false;

  const IS_B2B_VAL =
    localStorage.getItem("is_b2b") && localStorage.getItem("is_b2b") === "yes"
      ? true
      : false;

  if (authed && IS_CUSTOMER_VAL) return process.env.REACT_APP_GQL_CUSTOMER;
  if (authed && IS_B2B_VAL) return process.env.REACT_APP_GQL_AGENT;
  if (!authed) return process.env.REACT_APP_GQL_GUEST;
  return process.env.REACT_APP_GQL_DEFAULT;
}

const clientV3 = (endpoint) => {
  const authLink = setContext((_, { headers }) => {
    const isMiniApp = window.location.search.includes("miniapp");
    const tokenType = localStorage.getItem(
      isMiniApp ? "accessType" : "token_type",
    );
    const token = localStorage.getItem(isMiniApp ? "access" : "access_token");

    // Ensure correct format for BE
    const authHeader = token ? `${tokenType || "Bearer"} ${token}` : "";

    //console.log("Apollo Auth Header:", authHeader); // ✅ Debug log

    return {
      headers: {
        ...headers,
        authorization: authHeader,
      },
    };
  });

  const httpLinkV3 = createHttpLink({
    uri: process.env.REACT_APP_BE_SERVER + getGraphQLEndpoint(endpoint),
  });

  return new ApolloClient({
    link: authLink.concat(httpLinkV3),
    cache: new InMemoryCache(),
  });
};

export default clientV3;
